import { Platform, View } from 'react-native'
import { styled } from '~/utils'

export const Container = styled(View, theme => {
  return {
    base: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'center',
      gap: theme.spacingInlineOnepulse,
      width: '100%',
      paddingHorizontal: theme.paddingInsetTwopulse,
      paddingBottom: Platform.OS === 'ios' ? 10 : 0,
      backgroundColor: theme.colorFillNeutralDefault,
      borderWidth: theme.borderWidthNone,
      borderTopWidth: theme.borderWidthQuarterpulse,
      borderTopColor: theme.colorBorderNeutralAlternative,
    },
  }
})
